/* eslint-disable consistent-return */
export function parseComment(str, participants) {
  if (str) {
    const open = str.replace(/</g, '&lt;')
    const close = open.replace(/>/g, '&gt;')
    const comment = close.replace(/\s@/g, ' <@')
      .replace(/^@/, '<@')
      .split(/\s/g).map((item) => {
        if (item.startsWith('<@')) {
          let user_in_str = item.slice(2)
          if (user_in_str.slice(-1) === ',') {
            user_in_str = item.slice(2, -1)
          }
          const participant = participants.find(({ username }) => username === user_in_str)?.id
          return participant ? `<@${participant}>` : item
        }
        return item
      })

    return comment.join(' ')
  }
}

export function decodeComment(str, participants) {
  if (str) {
    const open = str.replace(/&lt;/g, '<')
    const close = open.replace(/&gt;/g, '>')

    const commentSplited = close.split(/<@(\S+)>/g)
    if (participants) {
      const comment = commentSplited.map(
        (item) => {
          const participant = participants.find(({ id }) => id == item)?.full_name
          return participant ? `**${participant}**` : item
        },
      )

      return comment.join(' ')
    }
    return close
  }
}
